<template>
  <NsSlottedDropdown
    :class="['slottedDropdown', { NsSlottedDropdown__small: size === 'small' }]"
    :label="label"
    :disabled="disabled"
    :placeholder="placeholder"
    :selected="selectedSku"
    :tall="tall"
    data-testid="variantSelector"
    @select="handleSelect"
  >
    <div
      v-for="item in variants"
      :key="item.id"
      :class="$style.item"
      :data-value="item.sku"
      :title="item.variantDropdownLabel"
    >
      <div
        v-if="!!item.shade"
        :class="$style.shade"
        :style="{ backgroundColor: item.shade }"
      />
      <div :class="$style.label">
        {{ item.variantDropdownLabel }}
      </div>
    </div>
  </NsSlottedDropdown>
</template>

<script>
import { NsSlottedDropdown } from "@nuskin/design-components";

/**
 * NsProductVariantSelector
 *
 * How to use:
 *
 * @event select  When a selection occurs this event emits a function with
 * params: (value, index)
 */

export default {
  name: "NsProductVariantSelector",
  components: { NsSlottedDropdown },
  props: {
    /**
     * Disables input
     */
    disabled: Boolean,
    /**
     * Label
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Sku of the current product
     */
    selectedSku: {
      type: String,
      default: ""
    },
    /**
     * The size of the selector.
     * @values large, small
     */
    size: {
      type: String,
      default: "large"
    },
    /**
     * Makes the component taller to match button height
     */
    tall: Boolean,
    /**
     * Array of variant skus
     */
    variantSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Array of variant options. Should be {id, sku, shade, label}
     */
    variants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    /**
     * Disables input
     */
    disable() {
      this.disabled = true;
    },
    /**
     * Enables input
     */
    enable() {
      this.disabled = false;
    },
    /**
     * Handle variant selection
     */
    handleSelect(value, index) {
      // if (!data.pristine && !this.settingVariants) {
      /**
       * Fired when a new variant is selected: function(value: string, index: number) => void
       *
       * @type {select}
       * @property {(string)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit("select", value, index);
      // this.variantIndex = data.index;
      // }
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/colors";
// div.slottedDropdown {
//   margin: 0;
//   display: block;
//   width: 100%;
//   @include global.p-small;
//   overflow: hidden;
// }

.item {
  display: flex;
  align-items: center;
  user-select: none;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: map.get(colors.$themeColors, color-interactive-5);
  }
}

.shade {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}

.label {
  flex: 1;
  display: inline-block;
  margin-left: 10px;
  // @include global.p-small;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
.slottedDropdown {
  margin: 0;
  display: block;
  width: 100%;
  ::v-deep .selected-item,
  ::v-deep .placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (max-width: 767px) {
  .slottedDropdown.NsSlottedDropdown__small {
    margin-top: 6px;
    width: 100%;

    ::v-deep .current-selection {
      min-height: 35px;
      height: 35px;
      border-radius: 6px;
    }

    ::v-deep .selected-item,
    ::v-deep .placeholder {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ::v-deep .placeholder {
      display: block;
    }

    ::v-deep .arrow-icon {
      flex-shrink: 0;
      margin-left: 8px;
    }
  }
}
</style>
